"use client";
import React, { Suspense, useEffect, useState, memo } from "react";
import { Box, Row, Columns, Button } from "@dxp-feed/ui";
import { SiteContainer } from "../../Container";
import HeaderLogo from "../HeaderLogo";
import HamburgerMenu from "../MegaMenu/HamburgerMenu";
import PrimaryList from "../PrimaryList";
import UserPoints from "../UserPoints";
import { Search } from "../Search/GlobalSearch";
import { StoreLocator } from "../StoreLocator";
import Loader from "../../Loader";
import { fetchHeaderContent } from "@/utils/SceneContent";

const HeaderTopSection = ({
  headerData,
  isPanelOpen,
  setIsPanelOpen,
  searchStaticAEMData,
  mobileMedia,
  isMobile,
}: any) => {
  const [quickLink, setQuicklink] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const getQuickLinks = async () => {
      try {
        const getLinks = await fetchHeaderContent();
        if (getLinks) {
          setQuicklink(getLinks);
        }
      } catch (error) {
        console.error("Error fetching scene content:", error);
      }
    };
    if (!quickLink) {
      getQuickLinks();
    }
  }, []); // empty dependency array here

  return (
    <>
      <Box as="div" className="bg-brandSecondary py-3">
        <SiteContainer>
          <Row className="pb-0">
            <Columns className={`col-12`}>
              <Box
                as="div"
                className="relative flex w-full max-w-none items-center justify-between lg:justify-normal "
              >
                <Box
                  as="div"
                  className="nav-toggle-bar lg:hidden flex justify-start items-center gap-[16px]"
                >
                  <Box
                    as="div"
                    className="nav-toggle-icon h-full w-auto flex items-center justify-center cursor-pointer"
                  >
                    <HamburgerMenu
                      quickLink={quickLink}
                      isPanelOpen={isPanelOpen}
                      setIsPanelOpen={setIsPanelOpen}
                      headerData={headerData["navigation_879072575"]}
                      searchStaticAEMData={searchStaticAEMData}
                      mobileLogoImage={headerData["header"]?.mobilelogoImage}
                    />
                  </Box>
                </Box>
                <Box
                  as="div"
                  className="mr-6 hidden w-full ml-6 lg:ml-0 lg:w-auto md:flex"
                >
                  <HeaderLogo
                    setIsPanelOpen={setIsPanelOpen}
                    headerData={headerData["header"]}
                  />
                </Box>
                {mobileMedia && mobileMedia >= 1024 && (
                  <Box className="store-locator hidden lg:flex">
                    <StoreLocator />
                  </Box>
                )}
                <Box
                  onClickCapture={() => {
                    if (isMobile) {
                      setVisible(true);
                    }
                  }}
                  className={` desktop-search block md:hidden lg:block z-10 ${
                    isMobile && visible
                      ? "[&_.overlay]:!hidden bg-brandSecondary mx-[-12px] [&_.dropDown]:!w-auto left-0 right-0 [&_.dropDown]:!left-[24px] py-[12px] px-[24px]  [&_.dropDown]:!right-[24px] absolute [&_.dropDown]:min-h-[calc(100vh-20vh)] [&_.dropDown]:!mt-[0px] z-[9999999] flex "
                      : "flex-1  !md:mx-0 !2lg:ml-6 !lg:mx-0 mr-3 3xl:mr-0 lg:!ml-3 ml-auto max-w-[calc(100%-90px)]"
                  } `}
                >
                  <Suspense fallback={<Loader />}>
                    <Search
                      placeholder={headerData["header"]?.searchplaceholder}
                      onClose={setVisible}
                      searchStaticAEMData={searchStaticAEMData}
                    />
                  </Suspense>
                  {visible && isMobile && (
                    <>
                      <Button
                        className={`!text-body 3xs:!text-base text-brandWhite !transition-none underline p-0 pl-3 pr-1 hover:none rounded-none border-none z-[9999999] relative `}
                        variant="icon"
                        aria-label={"Cancel"}
                        onClick={() => setVisible(false)}
                      >
                        Cancel
                      </Button>
                      <Box
                        as="div"
                        className="fixed w-full h-full z-[99] top-0 left-0 right-0 bg-overlay"
                        onClick={() => setVisible(false)}
                      >
                        {" "}
                      </Box>
                    </>
                  )}
                </Box>
                {mobileMedia <= 1023 && (
                  <Box className="">
                    <UserPoints />
                  </Box>
                )}

                <Box
                  as="div"
                  className=" justify-start hidden lg:flex 5xl:ml-10"
                >
                  <PrimaryList headerData={headerData["header"]} />
                </Box>
              </Box>
            </Columns>
          </Row>
        </SiteContainer>
      </Box>
    </>
  );
};

export default memo(HeaderTopSection);
